import { render } from "./Portfolio.vue?vue&type=template&id=a89fcce4&scoped=true&ts=true"
import script from "./Portfolio.ts?vue&type=script&lang=ts&external"
export * from "./Portfolio.ts?vue&type=script&lang=ts&external"

import "./Portfolio.vue?vue&type=style&index=0&id=a89fcce4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89fcce4"]])

export default __exports__